import DefaultValidation from "@/services/validations/DefaultValidation";
import * as Util from '@/functions/Util';

export default class PrazopagtoparcelaValidation extends DefaultValidation{

  validate(model = []) {
    let totalPercentual = 0;

    let invalid = false;
    let percentualInvalido = false;
    let hasInvalidDate = false;
    let hasSameDate = false;
    let hasInvalidPercentual = false;

    model.forEach(parcela => {
      totalPercentual += +parcela.percentual;

      // valida se tem dois dias com o mesmo valor
      let sameDate = model.filter(f => f.dias == parcela.dias);
      if(sameDate.length > 1) hasSameDate = true;

      // valida se tem dia vazio ou zerado
      if (Util.isNull(parcela.dias)||parcela.dias==0) {
        hasInvalidDate = true;
      }
      // valida se tem dia vazio ou zerado
      if (Util.isNull(parcela.percentual)||parcela.percentual==0) {
        hasInvalidPercentual = true;
      }

    });

    // valida se o percentual bate 100%
    if(totalPercentual != 100) percentualInvalido = true;

    if(percentualInvalido || hasInvalidDate || hasSameDate || hasInvalidPercentual) invalid = true;

    return {invalid, totalPercentual, percentualInvalido, hasInvalidDate, hasSameDate, hasInvalidPercentual};
  }
}